export const ERRORS_MESSAGE = {
  EMAIL_EXISTED: "このメールアドレスは既に登録されています。",
  REQUIRED: "必須項目です",
  PASSWORD_INVALID:
    "6文字以上、20文字以下、大文字、小文字、数字を少なくとも1文字ずつ含む必要です。",
  MATCH_NEW_PASSWORD: "パスワードは一致していません。",
  EMAIL_INVALID: "メールアドレスは正しい形式で入力してください。",
  PHONE_NUMBER_INVALID: "電話番号は10桁の数字で入力してください。",
  REGISTER_CODE_INVALID: "登録番号は数字とハイフンのみで入力してください。",
  CAN_NOT_BE_UPDATED_EMPTY: "入力済みの項目を空欄に変更することはできません。",
  MIN: "文字以上で入力してください。",
  MAX: "文字以内で入力してください。",
  KATAKANA_ONLY: "名前はカタカナで入力してください",
  UPLOAD_FAILED: "アップロードに失敗いたしました。",
  ERROR_CHECK_AGAIN: "エラーがあります。再度ご確認してください。",
  ERROR_401: "セッションの有効期限が切れました。再度ログインしてください。",
  DATA_SUBMIT_INVALID:
    "必須項目にデータが入力されていないため、保存することができません。",
  ERROR_GET_FAIL: "情報を取得できませんでした。",
  MAX_PHONE_LENGTH: `電話番号の入力は{MAX}桁以上である必要があります。`,
  DATA_INPUT_INVALID: "入力されたデータは有効なデータではありません。",
  USER_INVALID: "上記のユーザー情報を入力してください",
  SAVE_FAILED: "入力エラーがあります。",
  ZIPCODE: "郵便番号の形式が正しくありません。",
  COURSE_HAS_BEEN_DELETED: "コースは削除されました。",
  DUPLICATE_OPTION: "選択肢が重複しています。",
};

export const SUCCESSFUL_MESSAGE = {
  UPLOAD_SUCCESSFUL: "アップロードが成功しました。",
};

export const UNSAVED_CHANGES_WARNING_MESSAGE =
  "入力中の内容は削除してもよろしいですか？";

export const COMPANY_MESSAGES = {
  ADD_INVOICE_SUCCESS: "請求書の作成に成功しました",
  UPDATE_INVOICE_SUCCESS: "請求書の更新に成功しました",
  DELETE_INVOICE_SUCCESS: "請求書の削除に成功しました",
  ADD_BANK_INFO_SUCCESS: "銀行情報の作成に成功しました",
  UPDATE_BANK_INFO_SUCCESS: "銀行情報の更新に成功しました",
  DELETE_BANK_INFO_SUCCESS: "銀行情報の削除に成功しました",
  ADD_REGISTRATION_INFO_SUCCESS: "登記情報の作成に成功しました",
  UPDATE_REGISTRATION_INFO_SUCCESS: "登記情報の更新に成功しました",
  DELETE_REGISTRATION_INFO_SUCCESS: "登記情報の削除に成功しました",
  ADD_ACCOUNTING_PERIOD_SUCCESS: "会計期間の作成に成功しました",
  UPDATE_ACCOUNTING_PERIOD_SUCCESS: "会計期間の更新に成功しました",
  DELETE_ACCOUNTING_PERIOD_SUCCESS: "会計期間の削除に成功しました",
  ADD_TAX_HISTORIES_SUCCESS: "税務情報の作成に成功しました",
  UPDATE_TAX_HISTORIES_SUCCESS: "税務情報の更新に成功しました",
  DELETE_TAX_HISTORIES_SUCCESS: "税務情報の削除に成功しました",
};

export const ORGANIZATIONAL_CHART_MESSAGES = {
  YOU_DON_T_HAVE_PERMISSION_TO_DELETE: "ユーザーには削除権限がありません。",
  CURRENT_STATUS_CANNOT_BE_DELETED:
    "状態が「現行」になっている組織図は削除できません。",
};

export const CONTRACT_MESSAGES_CLONE_APP = {
  ONLY_SIGNER_CAN_SIGN: "本人のみ署名できます",
  ALREADY_SIGNED_CAN_NOT_SIGN_AGAIN:
    " すでに署名済みのため、再署名はできません。",
  COMPANY_SIDE_SIGN: "会社側から署名してください。",
  SIGNING_NOT_AVAILABLE_WHILE_DRAFTING:
    "現在は作成中のため、署名はできません。",
  EMPLOYEE_SIDE_SIGN: " 労働者側から署名してください。",
  SIGNING_NOT_AVAILABLE_WHILE_CREATING: "現在は作成中のため、署名はできません",
};
